<h4 class="fw-bold">
    {{ "landingPage.pillars.title" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<div class="bg-card shadow-md rounded p-2 mb-3">
    <form class="col-12" [formGroup]="pillarForm">
        <div class="bg-card shadow-md rounded p-2 mb-3">
            <div class="row">
                <div class="col-12">
                    <adaa-form-input
                        [label]="'common.form.label.refcode' | translate"
                        [setValidator]="formValidation()!"
                        formControlName="refCode"
                        controlName="refCode"
                        toUppercase
                        alphabetOnly
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('nameAE')"
                        formControlName="nameAE"
                        controlName="nameAE"
                        [adaaSmartToolTips]="'pillar_tool_tips_name_ae'"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('nameEN')"
                        formControlName="nameEN"
                        controlName="nameEN"
                        [adaaSmartToolTips]="'pillar_tool_tips_name_en'"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.descriptionAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('dscAE')"
                        formControlName="dscAE"
                        controlName="dscAE"
                        [adaaSmartToolTips]="'pillar_tool_tips_dsc_ae'"
                        [isTextArea]="true"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.descriptionEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('dscEN')"
                        formControlName="dscEN"
                        controlName="dscEN"
                        [adaaSmartToolTips]="'pillar_tool_tips_dsc_en'"
                        [isTextArea]="true"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 d-flex justify-content-center">
                    <adaa-form-checkbox
                        [label]="'common.form.label.available' | translate"
                        [checkboxMode]="'yesNo'"
                        controlName="available"
                        formControlName="available"
                    ></adaa-form-checkbox>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <adaa-form-two-way-select
                        [notSelectedLabel]="'rules_management.entities' | translate"
                        [selectedLabel]="'rules_management.selected_entities' | translate"
                        [setValidator]="formValidation()!"
                        [options]="enablerEntityOptions()"
                        [isDisabled]="pillarForm.get('pillarEntities')?.disabled ?? false"
                        formControlName="pillarEntities"
                        controlName="pillarEntities"
                        [adaaSmartToolTips]="'involvedEntities'"
                    ></adaa-form-two-way-select>
                </div>
            </div>
        </div>
    </form>
</div>

@if (isView()) {
    <div class="col-12 mb-3">
        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-primary" [routerLink]="['/console/pillars/list']">
                <span>{{ "common.form.button.close" | translate }}</span>
            </button>
        </div>
    </div>
} @else {
    <div class="col-12 mb-3">
        <adaa-form-action-buttons
            [saveButtonTitle]="'executive_teams.submit' | translate"
            (saveClicked)="updatePillar()"
            (cancelClicked)="cancelForm()"
        ></adaa-form-action-buttons>
    </div>
}
